export default {
  cancel: 'Скасувати рахунок',
  messages: {
    stripeWarning: 'Оплата через платіжну систему Stripe доступна тільки на  '
  }
};
